import AIFlowchartGenerator from "./AiFlowChart";

const FindFlowPage = () => <AIFlowchartGenerator />;

export default FindFlowPage;
